// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QfXQ","questions":"styles_questions__3Dskw","footer":"styles_footer__1MnBX"};